import styled from 'styled-components';

import {color, typography} from './styles';

const LabelStyles = styled.label`
  align-items: center;
  color: ${color.darker};
  display: flex;
  flex-direction: row;
  font-family: ${typography.type.primary};
  font-size: ${typography.size.s3};
  font-style: normal;
  font-weight: normal;
  justify-content: flex-start;
  line-height: 17px;

  &.visually-hidden {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
`;

export default LabelStyles;
